// Pinia Store

interface State {
  total: number | null
}

export const useProductSubscriptionStore = defineStore('product-subscription', {
  // convert to a function
  state: (): State => ({
    total: null,
  }),
  getters: {
  },
  actions: {
    async create(customer: string, product: string) {
      const { baseURL } = useRuntimeConfig().app
      const { $i18n, $storeErrorLog } = useNuxtApp()
      try {
        return await $fetch('/api/v2/products/subscriptions', {
          method: 'POST',
          body: { customer, product },
          baseURL,
          onResponseError({ response }) {
            if (response.status === 401) void useUserStore().reloadAuth()
          },
        })
      }
      catch (error: any) {
        $storeErrorLog('stores/product-subscription.ts', `Could not create product subscription for product: ${product}; customer: ${customer}`, $i18n.t('errors.page.unknown.subtitle'), error)
      }
    },
    async delete(customer: string, product: string) {
      const { baseURL } = useRuntimeConfig().app
      const { $i18n, $storeErrorLog } = useNuxtApp()
      try {
        const { data, error } = await useFetch(`/api/v2/products/subscriptions?customer=${customer}&product=${product}`, {
          method: 'DELETE',
          body: '{}',
          baseURL,
          onResponseError({ response }) {
            if (response.status === 401) void useUserStore().reloadAuth()
          },
        })
        if (error.value)
          throw error.value

        return data.value
      }
      catch (error: any) {
        $storeErrorLog('stores/product-subscription.ts', `Could not delete product subscription for product: ${product}; customer: ${customer}`, $i18n.t('errors.page.unknown.subtitle'), error)
      }
    },
    // easily reset state using `$reset`
    reset() {
      this.$reset()
    },
  },
})
